//#region Styles
import { Container } from "./styles";
//#endregion
//#region Images
import sadFaceSvg from "img/sad_face.svg";
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
import ErrorStack from "components/ErrorsStack/ErrorsStack";
import NotifyImportantMessage from "components/NotifyImportantMessage/NotifyImportantMessage";
import CloseButton from "components/CloseButton/CloseButton";
//#endregion

const ErrorStackDialog = ({
    show, toggleShow, 
    errorStack = []
}) => {
    return (
        <DialogAlert
            show={show}
            toggleShow={toggleShow}>
            <CloseButton onClick={() => toggleShow(false)}/>
            <Container>
                <header>
                    <div>
                        <img src={sadFaceSvg} alt="Errores formulario UTP"/>
                    </div>
                    <h3>Tenemos {errorStack.length} errores en tu archivo</h3>
                </header>
                <ErrorStack 
                    stack={errorStack}
                    complete/>
                <NotifyImportantMessage transparent message="Si quisieras tomarte una pausa o salir de esta ventana, tendrás que volver a empezar el proceso para ver tus errores."/>
            </Container>
        </DialogAlert>
    );
}

export default ErrorStackDialog;